// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"0":"1c1e35d9","4":"04208259","55":"d790200e","57":"f38f3164","89":"b7fc0bfc","309":"b0006cb8","440":"9bc5888f","460":"45ba15e9","536":"e479c1fe","662":"a89a58a8","700":"7e5eb13f","844":"9ede5b42","884":"1efa91a0","948":"7a7adfcc","955":"c71a9956"}[chunkId] + ".js";
};